import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CityDestinationsStoreEffects } from './effects';
import { CityDestinationsReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('cityDestinations', CityDestinationsReducer),
    EffectsModule.forFeature([CityDestinationsStoreEffects]),
  ],
})
export class CityDestinationsStoreModule {}
